import React from 'react'
import styles from './index.module.scss'

function Footer() {
    const currentYear = new Date().getFullYear()
    return (
        <footer className={`footer lx-text-center lx-bg-color-section ${styles.footer}`}>
            <p className="lx-fz14">大易云招聘 © {currentYear} Powered by Dayee.&nbsp;&nbsp;&nbsp;&nbsp;沪ICP备10000326号-6</p>
            {/* <p className="lx-fz14">Copyright © 2022 中国一汽 Powered By Dayee <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">沪ICP备10000326号-6</a></p> */}
        </footer>
    );
  }
  
  export default Footer;